import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_icon_file_text = _resolveComponent("b-icon-file-text")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_icon_map = _resolveComponent("b-icon-map")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_icon_image = _resolveComponent("b-icon-image")!
  const _component_b_form_file = _resolveComponent("b-form-file")!
  const _component_b_icon_trash = _resolveComponent("b-icon-trash")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_icon_pencil_square = _resolveComponent("b-icon-pencil-square")!
  const _component_b_icon_arrow_clockwise = _resolveComponent("b-icon-arrow-clockwise")!
  const _component_b_icon_geo = _resolveComponent("b-icon-geo")!
  const _component_b_icon_slash_circle = _resolveComponent("b-icon-slash-circle")!
  const _component_b_iconstack = _resolveComponent("b-iconstack")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_icon_file_text)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_textarea, {
                rows: "2",
                modelValue: _ctx.text,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event))
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      (_ctx.lat && _ctx.lon)
        ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { sm: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_icon_map)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Lat: " + _toDisplayString(_ctx.lat) + " Lon:" + _toDisplayString(_ctx.lon), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_select, {
                    modelValue: _ctx.location,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.location) = $event)),
                    options: _ctx.locations
                  }, null, 8, ["modelValue", "options"])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_icon_image)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_file, {
                onChange: _ctx.onFileChange,
                accept: "image/*",
                ref: "fileInput",
                multiple: "",
                placeholder: "Selected files show in below"
              }, null, 8, ["onChange"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
        return (_openBlock(), _createBlock(_component_b_row, {
          key: image.idx
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { sm: "1" }),
            _createVNode(_component_b_col, { sm: "3" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: image.url,
                  style: {"max-width":"200px","max-height":"200px","object-fit":"cover"}
                }, null, 8, _hoisted_1)
              ], undefined, true),
              _: 2
            }, 1024),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_button, {
                  onClick: ($event: any) => (_ctx.removeImage(image.idx))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_icon_trash)
                  ], undefined, true),
                  _: 2
                }, 1032, ["onClick"])
              ], undefined, true),
              _: 2
            }, 1024)
          ], undefined, true),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                onClick: _ctx.upload,
                disabled: _ctx.uploadState.disabled
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_icon_pencil_square, {
                    animation: _ctx.uploadState.animate
                  }, null, 8, ["animation"])
                ], undefined, true),
                _: 1
              }, 8, ["onClick", "disabled"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                onClick: _ctx.fetch,
                disabled: _ctx.fetchState.disabled
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_icon_arrow_clockwise, {
                    animation: _ctx.fetchState.animate
                  }, null, 8, ["animation"])
                ], undefined, true),
                _: 1
              }, 8, ["onClick", "disabled"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                onClick: _ctx.changeLocState,
                disabled: _ctx.locationState.disabled
              }, {
                default: _withCtx(() => [
                  (_ctx.allowState.loc)
                    ? (_openBlock(), _createBlock(_component_b_icon_geo, {
                        key: 0,
                        animation: _ctx.locationState.animate
                      }, null, 8, ["animation"]))
                    : (_openBlock(), _createBlock(_component_b_iconstack, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_icon_geo, { stacked: "" }),
                          _createVNode(_component_b_icon_slash_circle, {
                            stacked: "",
                            scale: "1.5"
                          })
                        ], undefined, true),
                        _: 1
                      }))
                ], undefined, true),
                _: 1
              }, 8, ["onClick", "disabled"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _hoisted_2
    ], undefined, true),
    _: 1
  }))
}